<script setup lang="ts">
import type { CheckboxGroupProps } from "./checkbox.types";
import { useCheckboxGroup } from "./useCheckboxGroup";

defineOptions({ name: "ECheckboxGroup" });

const props = withDefaults(defineProps<CheckboxGroupProps>(), {
  modelValue: () => [],
  color: "neutral",
  variant: "subtle",
  size: "md",
  disabled: false,
});

const { classes, ariaDisabled } = useCheckboxGroup({ props });
</script>

<template>
  <div part="base" :class="classes" role="group" :aria-disabled="ariaDisabled">
    <slot />
  </div>
</template>
